// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"4a41bfb1","453":"873070a2","553":"80193866","977":"e9c3d059"}[chunkId] + ".chunk.js";
};